import {useDispatch} from '../../../../state/hooks';
import * as PanelBankConfigActions from '../../../../state/views/panelBankConfig/actions';
import {useWorkspaceRefsContext} from '../../../Workspace/WorkspaceRefsContext';
import {useWorkspaceSettingsContext} from '../../Settings/WorkspaceSettingsContextProvider';
import {usePanelsQuickAddContext} from '../PanelsQuickAddContext';
import {MultiMetricPanelsMap} from './useMultiMetricPanelsMap';

export const useCreateMultiMetricPanels = (
  panelsToAdd: MultiMetricPanelsMap
) => {
  const dispatch = useDispatch();
  const {panelBankConfigRef} = useWorkspaceRefsContext();
  const {
    workspaceLayout: {sortAlphabetically},
  } = useWorkspaceSettingsContext();
  const {closeQuickAdd} = usePanelsQuickAddContext();

  return () => {
    const panelSpecs = Array.from(panelsToAdd.entries())
      .filter(([regex, {isAlreadyAdded}]) => !isAlreadyAdded)
      .map(([regex, {defaultSection}]) => ({
        type: 'regex-panel' as const,
        keyType: 'number' as const,
        metricRegex: regex,
        defaultSection,
      }))
      .map(spec => ({key: spec.metricRegex, spec}));
    dispatch(
      PanelBankConfigActions.addPanelsBySpec(
        panelBankConfigRef,
        panelSpecs,
        sortAlphabetically
      )
    );
    closeQuickAdd();
  };
};
